module.exports = __webpack_public_path__ + "static/img/shangbiao_05.43a0565.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shangbiao_05.png
// module id = K0HE
// module chunks = 0